/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



export interface AutomaticTranshipmentDetectionAttributes {
    'handlingType': AutomaticTranshipmentDetectionAttributesHandlingTypeEnum;
    'model'?: AutomaticTranshipmentDetectionAttributesModelEnum;
}

export enum AutomaticTranshipmentDetectionAttributesHandlingTypeEnum {
    Dry = 'dry',
    Liquid = 'liquid',
    Piece = 'piece',
    Pallet = 'pallet',
    Container = 'container',
    RoRo = 'roRo'
}
export enum AutomaticTranshipmentDetectionAttributesModelEnum {
    Disabled = 'disabled',
    Always = 'always',
    IntermodelChange = 'intermodelChange'
}


